<template>
    <login-form-position>
        <v-alert
            ref="auth-notice"
            v-model="anyNotice"
            dismissible
            type="success"
            class="elevation-12 shape cutie text-caption"
        >
            {{ anyNoticeMessage }}
        </v-alert>
        <alert-error id="errorMessage" v-model="anyError" :title="anyErrorMessage" dismissible class="elevation-12" />
        <the-login-tab
            :v-if="tabKeyNamesCreated"
            :domain-name="domainName"
            :saml-enabled="samlEnabled"
            :account-lock="isAccountLock"
            :verification-mail="isVerificationMail"
            :is-multi-auth="isMultiAuth"
            :tab-key-names="tabKeyNames"
            :mail-menu="mailDialogMenu"
        />
    </login-form-position>
</template>

<script setup lang="ts">
import { computed, readonly } from 'vue';
import { useUsrSettingStore } from '../../../store/modules/user_setting/composables';
import { AlertError } from '../../atoms';
import { TheLoginTab, LoginFormPosition } from '../../organisms';
import { useLoginPageLogic } from './composable/LoginPage';

/*
 * composables
 */
const {
    anyNotice,
    anyNoticeMessage,
    anyError,
    anyErrorMessage,
    beforeLoginSuccess,
    domainName,
    samlEnabled,
    isAccountLock,
    isVerificationMail,
    isMultiAuth,
    mailDialogMenu,
    isHardwareTokenRegister,
    isSoftDeviceRegisterable,
} = useLoginPageLogic();
const { beforeLogin } = useUsrSettingStore();

/*
 * setter, getters
 */
const tabKeyNames = computed(() => {
    const names = [{ id: 1, text: 'Login', icon: 'fa-sign-in-alt' }];
    if (isHardwareTokenRegister.value) {
        names.push({ id: 2, text: 'Multifactor_Authenticate_Device_Setting', icon: 'fa-plus' });
    }
    if (isSoftDeviceRegisterable.value) {
        names.push({ id: 3, text: 'Multifactor_Authenticate_Device_Setting', icon: 'fa-plus' });
    }
    return names;
});
const tabKeyNamesCreated = readonly(beforeLoginSuccess);

/**
 * lifecycle hooks
 */
beforeLogin();
</script>
